{
  "END_USER": "Usuario final",
  "MFA_REQUIRED": "Mfa requerido",
  "COMPANY_INFORMATION": "Información de la empresa",
  "COMPANY_NAME": "Nombre empresa",
  "ADDRESS1": "Calle",
  "ADDRESS2": "Direccion",
  "ZIP": "Codigo postal",
  "CITY": "Ciudad",
  "ORG_NUMBER": "NIF",
  "EMAIL_ADDRESS": "Email",
  "TELEPHONE": "Telefono",
  "WEBADDRESS": "Web",
  "QUOTATION": "Presupuesto",
  "NAME": "Nombre",
  "CUSTOMER": "Cliente",
  "YOUR_REFERENCE": "Referencia",
  "PAYMENT_TERMS": "Forma de pago",
  "DATE": "Fecha",
  "EXPIRE_DATE": "Fecha caducidad",
  "OUR_REFERENCE": "Nuestra referencia",
  "DELIVERY_TERMS": "Fecha entrega",
  "NOTES": "Notas",
  "PRICE_SUMMARY": "Tarifa",
  "ART_NO": "Referencia",
  "DESCRIPTION": "Descripcion",
  "QUANTITY": "Cantidad",
  "PRICE": "Precio",
  "DISCOUNT": "Descuento",
  "DISCOUNTED_PRICE": "Precio neto",
  "TOTAL_PRICE": "Precio total",
  "TOTAL_PRICE_AFTER_DISCOUNT": "Precio con descuento",
  "NEW_PRODUCTS": "Nuevos productos",
  "MY_ACCOUNT": "Mi cuenta",
  "PRICE_LIST": "Lista de precios",
  "PARTIAL_DELIVERY_EXPECTED": "Entrega parcial, primera entrega {{date}}",
  "ENTRY_IN_PROGRESS": "Entrada en progreso",
  "ENTERED": "Ingresado",
  "PICKING_IN_PROGRESS": "Recolección en curso",
  "INVOICED": "Facturado",
  "TOP_PRODUCTS": "Productos principales",
  "NOT_ADD_BROCHURES": "I do not want brochures",
  "ADD_BROCHURES": "Add brochures",
  "BROCHURES_DECISION_NECESSARY": "Brochures decision necessary",
  "SPARE_PARTS": "Piezas de repuesto",
  "TOTAL_VAT_INCLUDED": "Total IVA incluido: ",
  "VAT_PRECENTAGE": "IVA %",
  "VAT_VALUE": "Valor del IVA: ",
  "SAVE_AND_EMAIL_QUOTATION": "Guardar y enviar por correo electrónico",
  "TO_BE_PHASED_OUT": "En proceso de eliminación",
  "TARIFF_CODE": "Código arancelario",
  "REPLACES_NUMBER": "Sustituye número",
  "REPLACES_PRODUCT": "Reemplaza el producto",
  "NEWS_BANNER": "Nuevo",
  "CAMPAIGN_UNTIL": "Campaña hasta",
  "PRESELECTED_CUSTOMER_ID": "ID de cliente preseleccionado",
  "CHANGE_ACCOUNT": "Cambiar cuenta"
}
